import React from 'react';
import ChangePolicy from '../assets/images/icon-change-policy-disabled.svg';

export default () => {
  return <img src={ChangePolicy} alt="Disabled Change policy" />;
};
